module.exports = __webpack_public_path__ + "./IanPhoto_47d76a815c46ec5c2af3706bc4c50b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/IanPhoto.png
// module id = 479
// module chunks = 0